module.exports = __webpack_public_path__ + "static/malabrigo-white-545ca4098c1d784c8e2378c5f4eca76e.png";